import { action, computed, observable } from 'mobx';
import { DataStore, ToastStore, QueryStore } from '.';
import { generateGuid } from '../utils/generateGuid';
import { isNullOrUndefined } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';
import {
    AlertFeedbackMessage,
    FeedbackMessage,
    ToastFeedbackMessage,
} from '../Components/Feedback/Models';
import { FeedbackConfig } from '../models/configuration/FeedbackConfig';
export class FeedbackStore {
    queryStore: QueryStore;
    dataStore: DataStore;
    @observable.ref toasterMessages: Array<ToastStore>;
    @observable.ref alertMessage: AlertFeedbackMessage;

    constructor(dataStore: DataStore, queryStore: QueryStore) {
        this.queryStore = queryStore;
        this.dataStore = dataStore;
        this.toasterMessages = [];
    }

    @computed
    private get globalFeedbackConfig() {
        const { config } = this.dataStore;
        const { globalConfig } = config;
        return globalConfig.feedback;
    }

    /**
     * Adds a message to be displayed by the feedback component
     *
     * @param message The message to be displayed with any overriding config.
     */
    @action
    addMessage = (message: FeedbackMessage) => {
        const { config } = message;
        const workingConfig = config || this.globalFeedbackConfig;
        if (workingConfig) {
            if (workingConfig.feedbackMode === 'alert') {
                this.orchestrateAlert(message, workingConfig);
            }

            if (workingConfig.feedbackMode === 'toaster') {
                this.orchestrateToaster(message, workingConfig);
            }
        }
    };

    @action
    orchestrateAlert = (
        message: AlertFeedbackMessage,
        config: FeedbackConfig
    ) => {
        const { text, title, queryContext } = message;
        let textValue = text;
        let titleValue = title;
        const { alertOptions, textQuery } = config;

        textValue =
            this.queryStore.getValueFromQuery(textQuery, queryContext) ||
            textValue;

        if (alertOptions) {
            const { titleQuery } = alertOptions;
            titleValue =
                this.queryStore.getValueFromQuery(titleQuery, queryContext) ||
                titleValue;
        }

        this.alertMessage = {
            ...message,
            config,
            title: titleValue,
            text: textValue,
        };
    };

    @action
    orchestrateToaster = (
        message: ToastFeedbackMessage,
        config: FeedbackConfig
    ) => {
        const key = generateGuid();
        const { text, queryContext } = message;
        let textValue = text;
        const { textQuery } = config;

        textValue =
            this.queryStore.getValueFromQuery(textQuery, queryContext) ||
            textValue;

        const workingMessage = { ...message, config, text: textValue };
        const toastStore = new ToastStore(
            {
                feedback: this,
                data: this.dataStore,
            },
            key,
            workingMessage
        );
        // Force reset of toaster messages for mobx prop update
        this.toasterMessages = [...this.toasterMessages, toastStore];
    };

    @action
    removeToast = (key: string) => {
        this.toasterMessages = this.toasterMessages.filter(
            toastStore => toastStore.key !== key
        );
    };

    @action
    removeAlert = () => {
        this.alertMessage = null;
    };

    @computed
    get hasAlertFeedback() {
        return !isNullOrUndefined(this.alertMessage);
    }
}



// WEBPACK FOOTER //
// ./src/stores/FeedbackStore.ts